import { Description, Dialog, DialogPanel, DialogTitle, Transition } from '@headlessui/react';
import React, { Fragment } from 'react';

const CustomDialog = ({ isOpen, onClose, title, message, isSuccess, onProceed }) => {
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-100"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/80 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="transition duration-100 ease-out"
              enterFrom="transform scale-95 opacity-0"
              enterTo="transform scale-100 opacity-100"
              leave="transition duration-75 ease-out"
              leaveFrom="transform scale-100 opacity-100"
              leaveTo="transform scale-95 opacity-0"
            >
              <Dialog.Panel className="w-full max-w-xl transform bg-white shadow-xl transition-all text-center px-6 md:px-10 py-10 md:py-14">

                {!isSuccess && (
                  <div className="text-left mb-5 md:mb-10">
                    <DialogTitle className="font-bold text-lg/6 md:text-xl md:pr-10 mb-5 md:mb-10">{title}</DialogTitle>
                    <p className="text-sm/6">{message}</p>
                  </div>
                )}

                {isSuccess && (
                  <div className="text-center flex flex-col items-center gap-5">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" className="text-purple size-12">
                      <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                    </svg>
                    <DialogTitle className="font-bold text-lg md:text-xl px-10 md:px-20">{title}</DialogTitle>
                    <p className="text-sm/6">{message}</p>
                  </div>
                )}

                <div className="flex gap-5">
                  {!isSuccess && (
                  <button onClick={onClose} className="primary w-full">
                    Daten überprüfen
                  </button>
                  )}
                  {isSuccess && (
                    <button onClick={onProceed} className="primary w-full mt-5">
                      Weiter zur Nominierung
                    </button>
                  )}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default CustomDialog;
